import React, {
  createContext,
  type ReactNode,
  useContext,
  useState,
} from 'react'
import styled from 'styled-components'

const ChatbotDockHostElement = styled.div`
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-self: stretch;
  min-height: 0;
  min-width: 0;
  overflow: hidden;
`

const ChatbotDockContext = createContext<{
  host: HTMLElement | null
  setHost: (element: HTMLDivElement | null) => void
} | null>(null)

/** DOM mount target for the portaled chat panel. */
export function useChatbotDockHost(): HTMLElement | null {
  return useContext(ChatbotDockContext)?.host ?? null
}

export function ChatbotDockProvider({ children }: { children: ReactNode }) {
  const [host, setHost] = useState<HTMLDivElement | null>(null)

  return (
    <ChatbotDockContext.Provider value={{ host, setHost }}>
      {children}
    </ChatbotDockContext.Provider>
  )
}

/** Right-hand column in the embedded-sidebar shell; the chat panel mounts here. */
export function ChatbotDockHost() {
  const dock = useContext(ChatbotDockContext)
  if (dock === null) {
    throw new Error('ChatbotDockHost must be used within ChatbotDockProvider')
  }

  return <ChatbotDockHostElement ref={dock.setHost} data-chatbot-dock='right' />
}
